
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/mining/trade/invitations",
      function () {
        return require("private-next-pages/lon/mining/trade/invitations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/mining/trade/invitations"])
      });
    }
  